import "./StreamerHotkeys.scss"

import React, { memo, useCallback, useEffect, useRef, useState } from "react"

import { useLayerPopupContext } from "@shared/contexts"
import { store } from "@shared/modules"

import HotkeyList from "./HotkeyList"

const HOTKEY_MAX_LENGTH = 500

const initHotkey = Array.from(new Set(Array(10).keys()))
  .map((index) => store.local.get(`macro.F${index + 1}`))
  .filter((hotkey) => hotkey)

function StreamerHotkeys() {
  const { open, alert } = useLayerPopupContext()

  const [hotkeys, setHotkeys] = useState<string[]>(initHotkey)
  const opener = window.opener
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const [selectedHotkey, setSelectedHotkey] = useState<Hotkey>()
  const [selectedIndex, setSelectedIndex] = useState<number[]>([])

  const Alert = useCallback(
    (message: string) => {
      alert.handleAlert({ contents: message })
      open("ALERT")
    },
    [alert, open],
  )

  const handleLocalStorage = useCallback(
    (hotkeys: string[]) => {
      try {
        opener.subscribeHotkeysLocalStorage(hotkeys)
      } catch (e) {
        Alert("단축키 지정에 실패했습니다.")
        return
      }
      Alert("단축키를 지정했습니다.")
    },
    [opener, Alert],
  )

  const handleSelectedHotkey = useCallback((hotkey: Hotkey | undefined) => {
    setSelectedHotkey(hotkey)
  }, [])

  const handleSelectedIndex = useCallback((index: number[]) => {
    setSelectedIndex(index)
  }, [])

  const initTextarea = () => {
    if (!textareaRef.current) return

    textareaRef.current.value = ""
  }

  useEffect(() => {
    if (!textareaRef.current || selectedHotkey === undefined) return

    textareaRef.current.value = selectedHotkey.key
    textareaRef.current.focus()
  }, [selectedHotkey])

  return (
    <div className="custom hotkeys">
      <article
        className="popup"
        style={{ width: "510px", marginLeft: "-255px" }}
      >
        <div className="titB">
          <h3>채팅지원 - 자주 쓰는 안내멘트</h3>
        </div>
        <div className="innerB">
          <div className="txtA">
            <textarea
              name=""
              id=""
              cols={30}
              rows={10}
              placeholder="최초 등록할 안내멘트 입력"
              ref={textareaRef}
              maxLength={HOTKEY_MAX_LENGTH}
            ></textarea>
          </div>
          <div className="btnB">
            <a
              href="#!"
              title="취소"
              onClick={(e) => {
                e.preventDefault()

                initTextarea()
                setSelectedHotkey(undefined)
              }}
            >
              취소
            </a>
            <a
              href="#!"
              className="on"
              title="저장"
              onClick={(e) => {
                e.preventDefault()

                if (!textareaRef || !textareaRef.current) return

                if (!textareaRef.current.value)
                  return Alert("멘트를 입력해주세요")

                if (!selectedHotkey && hotkeys.length > 9)
                  return Alert("안내멘트가 가득찼습니다.")

                const newHotkeys = Array.from(
                  new Set(
                    selectedHotkey
                      ? hotkeys.map((hotkey, index) => {
                          if (index === selectedHotkey.index)
                            return textareaRef.current!.value

                          return hotkey
                        })
                      : [...hotkeys, textareaRef.current.value],
                  ),
                )
                initTextarea()

                setHotkeys(newHotkeys)
                handleLocalStorage(newHotkeys)
                setSelectedHotkey(undefined)
              }}
            >
              저장
            </a>
          </div>
          <HotkeyList
            hotkeys={hotkeys}
            selectedIndex={selectedIndex}
            selectedHotkey={selectedHotkey}
            handleSelectedIndex={handleSelectedIndex}
            handleSelectedHotkey={handleSelectedHotkey}
          />
          <div className="btnB">
            <a
              href="#!"
              title="삭제"
              onClick={(e) => {
                e.preventDefault()

                initTextarea()
                setSelectedHotkey(undefined)
                if (!selectedIndex.length) return

                const filteredHotkeys = [...hotkeys].filter(
                  (hotkey, index) => !selectedIndex.includes(index),
                )

                setHotkeys(filteredHotkeys)
                setSelectedIndex([])

                handleLocalStorage(filteredHotkeys)
              }}
            >
              삭제
            </a>
            <a
              href="#!"
              className="on"
              title="등록"
              onClick={(e) => {
                e.preventDefault()

                textareaRef.current?.focus()
              }}
            >
              등록
            </a>
          </div>
        </div>
      </article>
    </div>
  )
}
export default memo(StreamerHotkeys)

export interface Hotkey {
  key: string
  index: number
}
